const PENDING_CLASS = 'jarabot-widget-pending';
const SHAKE_CLASS = 'jarabot-widget-shake';
const MAX_PENDING_DURATION_MS = 20_000;

let pendingTimeoutId: ReturnType<typeof setTimeout> | null = null;

function getBubbleEl(): HTMLElement | null {
	return document.querySelector('.woot-widget-bubble');
}

export function clearPendingIndicator(): void {
	getBubbleEl()?.classList.remove(PENDING_CLASS);
	if (pendingTimeoutId) {
		clearTimeout(pendingTimeoutId);
		pendingTimeoutId = null;
	}
}

export function showPendingIndicator({ shake }: { shake?: boolean } = {}): void {
	const el = getBubbleEl();
	if (!el) return;

	el.classList.add(PENDING_CLASS);
	if (pendingTimeoutId) clearTimeout(pendingTimeoutId);
	pendingTimeoutId = setTimeout(clearPendingIndicator, MAX_PENDING_DURATION_MS);

	if (shake) {
		el.classList.remove(SHAKE_CLASS);
		el.getBoundingClientRect();
		el.classList.add(SHAKE_CLASS);
		el.addEventListener('animationend', () => el.classList.remove(SHAKE_CLASS), { once: true });
	}
}

if (typeof window !== 'undefined') {
	(['jarabot:on-message', 'jarabot:on-start-conversation', 'jarabot:error'] as const).forEach(
		(eventName) => window.addEventListener(eventName, clearPendingIndicator)
	);
}
